import { HOT_AND_COLD_SECTION_NAME } from '@repo/common';
import type ISectionSettings from 'types/models/ISectionSettings';

type HotColdSectionSettings = ISectionSettings & {
  hotColdSettings: NonNullable<ISectionSettings['hotColdSettings']>;
};

export const getIsHotColdSection = (data: ISectionSettings): data is HotColdSectionSettings => {
  return data.name === HOT_AND_COLD_SECTION_NAME && Boolean(data.hotColdSettings);
};
